import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-loading-panel',
  templateUrl: './loading-panel.component.html',
  styleUrls: ['./loading-panel.component.scss']
})
export class LoadingPanelComponent implements OnInit {

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {

  }

}
